import { Dialog } from '../../../../../../common/dialog';

import About from './about';
import { USER_OPTIONS } from './interfaces';
import AccountInformation from './account-information';
import LowBalanceNotification from './low-balance-notification';
import ClientSecretsRegeneration from './client-secrets-regeneration';
import AddFundsToYourWallet from '../../../../client-balance/add-funds-to-your-wallet';

interface Props {
  open: boolean;
  locked: boolean;
  handleClose: () => void;
  handleLock: () => void;
  handleUnlock: () => void;
  option: USER_OPTIONS;
}

const DialogContentHandler = ({ open, locked, handleClose, handleLock, handleUnlock, option }: Props) => {
  switch (option) {
    case USER_OPTIONS.ADD_FUNDS_TO_YOUR_WALLET:
      return (
        <Dialog
          width="100%"
          open={open}
          title="Edit account information"
          handleClose={handleClose}
          disableBackdropClose={true}
          locked={locked}
          ignoreMinHeight={true}
        >
          <AddFundsToYourWallet handleClose={handleClose} />
        </Dialog>
      );
    case USER_OPTIONS.ACCOUNT_INFORMATION:
      return (
        <Dialog
          width="100%"
          open={open}
          title="Edit account information"
          handleClose={handleClose}
          disableBackdropClose={true}
          locked={locked}
        >
          <AccountInformation handleClose={handleClose} handleUnlock={handleUnlock} />
        </Dialog>
      );
    case USER_OPTIONS.CLIENT_SECRETS_REGENERATION:
      return (
        <Dialog
          width="100%"
          open={open}
          title="Client secrets regeneration"
          handleClose={handleClose}
          disableBackdropClose={true}
          locked={locked}
        >
          <ClientSecretsRegeneration handleClose={handleClose} handleLock={handleLock} handleUnlock={handleUnlock} />
        </Dialog>
      );
    case USER_OPTIONS.LOW_BALANCE_NOTIFICATION:
      return (
        <Dialog
          width="100%"
          open={open}
          title="Low balance notification settings"
          disableBackdropClose={true}
          handleClose={handleClose}
        >
          <LowBalanceNotification handleClose={handleClose} handleUnlock={handleUnlock} />
        </Dialog>
      );
    case USER_OPTIONS.ABOUT:
      return (
        <Dialog width="100%" open={open} title="About" handleClose={handleClose}>
          <About handleUnlock={handleUnlock} />
        </Dialog>
      );
    default:
      return null;
  }
};

export default DialogContentHandler;
